import BaseReducer from "./BaseReducer";

class LinkSessionReducer extends BaseReducer {
  domain = "LinkSession";
  type = "View";

  initialState = {
    name: "session",
    isComplianceSessions: false,
    linkSession: null,
    linkedSessionData: [],
    activeAccordionIndex: [0, 1],
  };
}

const reducer = new LinkSessionReducer();

export default reducer;
